var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditTraceability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.923,
    height: 12,
    viewBox: "0 0 12.923 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit_1_",
    "data-name": "edit (1)",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5877",
    "data-name": "Rectangle 5877",
    width: 12.923,
    height: 0.923,
    transform: "translate(2 13.077)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21022",
    "data-name": "Path 21022",
    d: "M13.877,5.231a.892.892,0,0,0,0-1.292h0L12.215,2.277a.892.892,0,0,0-1.292,0h0L4,9.2v2.954H6.954ZM11.569,2.923l1.662,1.662L11.846,5.969,10.185,4.308ZM4.923,11.231V9.569L9.538,4.954,11.2,6.615,6.585,11.231Z",
    transform: "translate(-1.077)",
    fill: "#203662"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTraceability);
export default __webpack_public_path__ + "static/media/Edit_Traceability.861b5e8d0325ca02cd0731753752ade3.svg";
export { ForwardRef as ReactComponent };